import { useAuth } from "@/core/hooks/useAuth";
import Loading from "@/shared/components/Loading";
import { Box, useMantineTheme } from "@mantine/core";
import { Outlet } from "react-router-dom";

export const RootLayout = () => {
  const theme = useMantineTheme();
  const { isUserLoading, token } = useAuth();

  return (
    <Box
      bg={theme.colors["background_3"][0]}
      mih="100vh">
      {token && isUserLoading ? <Loading /> : <Outlet />}
    </Box>
  );
};
